module.exports = __webpack_public_path__ + "static/img/cj14.00d0cfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cj14.png
// module id = 156
// module chunks = 0